/** Teksty hero / intro — jedno źródło dla spójnej narracji ładowania i strony głównej */
export const HOME_HERO_OVERLINE =
  "Fryzjer męski · barbershop · Praga Północ · Warszawa";

/** Jeden H1 na stronie — marka; lokalizacja jest w overline + lead + JSON-LD (bez powtórzeń w dużym typie). */
export const HOME_HERO_HEADING = "SZNYT Barbershop";

export const HOME_HERO_SUBTITLE =
  "Barbershop i fryzjer męski na Pradze Północ — strzyżenie męskie, broda i styl w sercu Warszawy. Luźna atmosfera, rzemiosło i cięcia na poziomie. Szukasz dobrego barbershopu w Pradze lub centrum? Zarezerwuj wizytę w Booksy.";

/** Skrót w sekwencji intro (pełny akapit zostaje na hero) */
export const HOME_HERO_SUBTITLE_TEASER =
  "Strzyżenie męskie, broda i styl w sercu Warszawy — luźna atmosfera i rzemiosło.";

export const HOME_HERO_CTA_LABEL = "Rezerwacja";
